/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/camelcase */
import React, { useContext } from 'react';
import loader from '../../../../../../assets/img/icons/TizetiLoaderColored.gif';
// import { TowersProps } from './types/TowersProps';
import GeniatechContext from '../../../../../../context/GeniatechContext';

const TowersTable = () => {
  const { loading, data, searchData } = useContext(GeniatechContext);
  const getInformation = (params) => {
    searchData({
      action: 'tower_information',
      offset: '0',
      limit: '100',
      network_id: 'tz-xwf',
      tower_id: params.name,
    });
  };
  const tableData =
    data && data.length
      ? data.map((row, i) => (
          <tr className="text-nowrap" style={{ cursor: 'pointer' }} key={i + 1} onClick={() => getInformation(row)}>
            <td>{i + 1}</td>
            <td>{row.id}</td>
            <td>{row.name}</td>
            <td>{row.network}</td>
            <td>{row.location.type}</td>
            <td>{row.location.coordinates}</td>
            <td>{row.managed_account}</td>
          </tr>
        ))
      : 'no towers';
  return (
    <div className="card x-panel mt-2 px-0">
      <div className="table-responsive content col-12 px-1">
        <table className="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Tower ID</th>
              <th className="text-nowrap">Name</th>
              <th>Network</th>
              <th>Location Type</th>
              <th>Location Coordinates</th>
              <th>Managed Account</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <img src={loader} alt="loading gif" />
              </tr>
            ) : (
              tableData
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TowersTable;
